import $axios from "@/api";
import helper from "@/assets/js/helper.js";

const state = () => ({
    data_filter : {
        form : false,
        modal : false,
        request : false,

        id_perusahaan : [],
        id_depo : [],

        start_date: helper.methods.dateTime('ymd'),
        end_date: helper.methods.dateTime('ymd'),

        id_principal : [],
        id_brand : [],

        id_tim : 0,

        page: 1,
        per_page: 10,
    },
    cart_navigation : {
        currentPage : '1',
        rows : '10',
        perPage : '10',
        notShowed : [],
    },
    data_tim_aktif : {
        cop : [],
        data : []
    },
    data_cart : {},
    data_laporan : {
        data : {
            nama_tim : []
        },
    },
})

const mutations = {
    FILL_DATA(state, payload=null) {
        let notShowed = state.cart_navigation.notShowed.sort();
        let currentPage = typeof payload === 'object' ?  state.cart_navigation.currentPage : payload
        let startPage = (currentPage - 1) * state.cart_navigation.perPage
        let endPage = (currentPage) * state.cart_navigation.perPage
        let data = {...state.data_laporan.data}
        let data_tim = [...data.nama_tim]
        let data_dpp = [...data.dpp]
        

        for (let i = notShowed.length - 1; i >=0 ; i--) {
            data_tim.splice(notShowed[i],1)
            data_dpp.splice(notShowed[i],1)
        }

        data_tim = data_tim.length > 5 ? data_tim.slice(startPage, endPage) : data_tim
        data_dpp = data_tim.length > 5 ? data_dpp.slice(startPage, endPage) : data_dpp
        state.data_cart = {
            labels: data_tim,
            height: 300,
            datasets: [
            {
                backgroundColor: "#dbe8f5",
                borderColor: "#206bc4",
                data: data_dpp,
                label: "Grand Total"
            }
            ]
        };
    },
}

const actions = {
    triggerFilter({state, commit, payload}){
        let is_modal = state.data_filter.modal ? false : true;
        if(is_modal){
            state.data_filter.form = is_modal;
            setTimeout(() => {
              state.data_filter.modal = is_modal;
            }, 100);
        }
        else{ 
            state.data_filter.modal = is_modal;
            setTimeout(() => {
                state.data_filter.form = is_modal;
            }, 100);
        }
    },
    getLaporan( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`kpi/dashboard`, {
                params: state.data_filter
            }).then((response) => {
                state.data_laporan.data = response.data
                state.cart_navigation.rows = response.data.nama_tim.length
                commit('FILL_DATA')
            })
        })
    },
    getDetail( {state, commit }, payload) {
        state.data_filter.id_tim = payload.id
        return new Promise( (resolve, reject) => {
            $axios.get(`kpi/dashboard/detail`, {
                params: state.data_filter
            }).then((response) => {
                console.log(response.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
